import React, { useState } from "react";

import { Container, Row, Col, Label } from "reactstrap";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import notificationManager from "managers/notificationManager";
import { formatDateManager } from "managers/formatDateManager";
import { staticData } from "managers/staticDataManager";
import { dataManager } from "managers/data/dataManager";

import DownloadItem from "components/DownloadItem";

import { loadPublicSingleDocument } from "../../callApi";

const DocumentPreview = (params) => {
  const state = useSelector((state) => state);
  const history = useHistory();

  const notificationReference = React.useRef(null);

  const [isBusy, setIsBusy] = useState(false);
  const [documentData, setDocumentData] = useState(null);

  React.useEffect(() => {
    if (params?.match?.params?.publicId) {
        loadPublicSingleDocument(state, setDocumentData, params?.match?.params?.publicId, setIsBusy, notificationReference);
        return;
    }

    // console.log('React.useEffect-history?.location?.state?.documentData: ', history?.location?.state?.documentData);
    if (!history?.location?.state?.documentData?.publicId) {
        notificationManager.error(state, null, notificationReference, 'VW_COMMON_ILEGAL_OPERATION');
        return;
    }

    loadPublicSingleDocument(state, setDocumentData, history?.location?.state?.documentData?.publicId, setIsBusy, notificationReference);
  }, [history?.location?.state?.documentData, params?.match?.params?.publicId])
//   React.useEffect(() => {
//     console.log('React.useEffect-documentData: ', documentData);
//     console.log('React.useEffect-documentData.sort: ', (documentData && documentData.attachments?documentData.attachments:[]).sort((a, b) => a?.attachmentId - b?.attachmentId));
//   }, [documentData])
  
  const loadIssuerLogo = (data) => {
    //console.log('loadIssuerLogo-data: ', data?.issuerLogo, data?.issuer, dataManager.getIssuerDisplayName(state, data?.issuer));
    return data?.issuerLogo?.content
    ? (
        <div>
            <img width="120px" //height="200px" 
                alt={dataManager.getIssuerDisplayName(state, data?.issuer)}
                src={`data:image/jpeg;base64,${data.issuerLogo.content}`} />
        </div>
      )
    : (<div><h3>{dataManager.getIssuerDisplayName(state, data?.issuer)}</h3></div>);
  }
  const renderContent = (data) => {
      return <div dangerouslySetInnerHTML={{ __html: data }} />;
  }

  return (
    <main className="main text-center">
        <Container>
            <Row style={{color: '#f5593d'}}>
                <Col className="mt-3" >
                    <strong>
                    <i  className="nc-icon nc-minimal-left" 
                        title={staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_PREVIOUS")}
                        onClick={(e)=>{
                            if (documentData?.issuerLink?.previous)
                            history.push(`/document/${documentData?.issuerLink?.previousId}`);
                        }}
                        onMouseOver={(e) => {
                            e.target.style.cursor = 'pointer';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.cursor = 'default';
                        }}
                    />
                    {/* <Label 
                        onClick={(e)=>{
                            // console.log('Label-onClick: ', documentData?.issuerLink?.previousId);
                            history.push("/document", { documentData: { documentId : documentData?.issuerLink?.previousId } });
                        }}
                    >
                        {staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_PREVIOUS")}
                    </Label> */}
                    <Label title={staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_BYISSUER_HOVER")}>
                        {staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_BYISSUER")}
                    </Label>
                    <i  className="nc-icon nc-minimal-right" 
                        title={staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_NEXT")}
                        onClick={(e)=>{
                            if (documentData?.issuerLink?.next)
                            history.push(`/document/${documentData?.issuerLink?.nextId}`);
                        }}
                        onMouseOver={(e) => {
                            e.target.style.cursor = 'pointer';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.cursor = 'default';
                        }}
                    />
                    </strong>
                    {/* <Label 
                        onClick={(e)=>{history.push("/document", { documentData: { documentId : documentData?.issuerLink?.nextId } })}}
                    >
                        {staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_NEXT")}
                    </Label> */}
                </Col>
                <Col className="mt-3"></Col>
                <Col className="mt-3">
                    <strong>
                    <i  className="nc-icon nc-minimal-left" 
                        title={staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_PREVIOUS")}
                        onClick={(e)=>{
                            if (documentData?.layoutLink?.previous)
                            history.push(`/document/${documentData?.layoutLink?.previousId}`);
                        }}
                        onMouseOver={(e) => {
                            e.target.style.cursor = 'pointer';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.cursor = 'default';
                        }}
                    />
                    {/* <Label 
                        onClick={(e)=>{history.push("/document", { documentData: { documentId : documentData?.layoutLink?.previousId } })}}
                    >
                        {staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_PREVIOUS")}
                    </Label> */}
                    <Label title={staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_BYLAYOUT_HOVER")}>
                        {staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_BYLAYOUT")}
                    </Label>
                    <i  className="nc-icon nc-minimal-right" 
                        title={staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_NEXT")}
                        onClick={(e)=>{
                            if (documentData?.layoutLink?.next)
                            history.push(`/document/${documentData?.layoutLink?.nextId}`);
                        }}
                        onMouseOver={(e) => {
                            e.target.style.cursor = 'pointer';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.cursor = 'default';
                        }}
                    />
                    </strong>
                    {/* <Label 
                        onClick={(e)=>{history.push("/document", { documentData: { documentId : documentData?.layoutLink?.nextId } })}}
                    >
                        {staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_NEXT")}
                    </Label> */}
                </Col>
            </Row>
            <Row>
                <Col className="text-center ml-auto mr-auto" md="11">
                    {loadIssuerLogo(documentData)}
                </Col>
            </Row>
            <Row>
                <Col>
                    <div dangerouslySetInnerHTML={{__html:documentData?.layout?.header}}></div>
                </Col>
            </Row>
            {/* <Row>
                <Col className="ml-auto mr-auto" md="8">
                    <h3 className="title">{staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_TITLE")}</h3>
                </Col>
            </Row> */}
            {/* <Row>
                <Col className="ml-auto mr-auto" md="8">
                    {`${documentData?.documentId} ${documentData?.layout?.description} ${loadIssuerDisplayName(documentData)}`}
                </Col>
            </Row> */}
            <Row>
                <Col className="text-left ml-auto mr-auto" md="11" style={{color: 'black'}}>
                    <div>{renderContent(documentData?.content)}</div>
                </Col>
            </Row>
            <Row>
                <Col>
                    <div dangerouslySetInnerHTML={{__html:documentData?.layout?.footer}}></div>
                </Col>
            </Row>
            <Row>
                <Col className="text-center ml-auto mr-auto" md="11">
                    {
                        (documentData && documentData.attachments?documentData.attachments:[]).sort((a, b) => a?.attachmentId - b?.attachmentId).map((file, index) => {
                            return ( 
                                <strong>
                                <DownloadItem
                                    file={file}
                                    key={`file-${index}`}
                                    busyHandler={setIsBusy}
                                    alertRef={notificationReference}
                                /> 
                                </strong>
                            );
                        })
                    }
                </Col>
            </Row>
            <Row>
                <Col className="text-right ml-auto mr-auto mt-5" md="11">
                    <div>{staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_PUBLISHEDON")}: {formatDateManager.formatStandardWithTime(documentData?.publishedDate)}</div>
                    <div>{staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_PUBLICID")}: {documentData?.publicId}</div>
                    <div>{staticData.loadTerms(useSelector, "VW_DOCUMENT_PREVIEW_LAYOUT")}: {documentData?.layout?.description}</div>
                </Col>
            </Row>
        </Container>
    </main>
  )
}
export default DocumentPreview;